import { fetchApi } from "./fetchApi";

export default {
  createTestStep(releaseNoteId, testStep) {
    const data = {
      scenario: testStep.scenario,
      stepNumber: parseInt(testStep.stepNumber, 10),
      substepNumber: parseInt(testStep.substepNumber, 10),
      expectedOutcome: testStep.expectedOutcome,
    };
    return fetchApi({
      data,
      method: "post",
      url: `/api/releaseNote/${releaseNoteId}/testStep`,
    });
  },
  deleteTestStep(testStepId, shiftTestSteps) {
    return fetchApi({
      method: "delete",
      url: `/api/testStep/${testStepId}?shiftSteps=${shiftTestSteps}`,
    });
  },
  getTestStep(testStepId) {
    return fetchApi({
      method: "get",
      url: `/api/testStep/${testStepId}`,
    });
  },
  list(releaseNoteId) {
    return fetchApi({
      method: "get",
      url: `/api/releaseNote/${releaseNoteId}/testStep`,
    });
  },
  memberList(releaseNoteId, serviceArea) {
    return fetchApi({
      method: "get",
      url: `/api/releaseNote/${releaseNoteId}/testPlan/${serviceArea}/testStep`,
    });
  },
  updateMemberStep(memberTestStep) {
    const data = {
      actualOutcome: memberTestStep.actualOutcome,
      testingDetails: memberTestStep.testingDetails,
    };

    return fetchApi({
      data,
      method: "put",
      url: `/api/testStep/${memberTestStep.testPlanStepId}/serviceArea/${memberTestStep.serviceAreaId}`,
    });
  },
  updateTestStep(testStep) {
    const data = {
      scenario: testStep.scenario,
      stepNumber: parseInt(testStep.stepNumber, 10),
      substepNumber: parseInt(testStep.substepNumber, 10),
      expectedOutcome: testStep.expectedOutcome,
    };

    return fetchApi({
      data,
      method: "put",
      url: `/api/testStep/${testStep.id}`,
    });
  },
};
